import script from "./InformationPanelLanguageList.component.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationPanelLanguageList.component.vue?vue&type=script&setup=true&lang=js"

import "./InformationPanelLanguageList.component.vue?vue&type=style&index=0&id=7e70471a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e70471a"]])

export default __exports__